import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Modal, Button, Input, Select, Icon, Popover } from 'antd';
import {
  ModalBody,
  ModalContainer,
  InputLabel,
  Container,
  InputContainer,
  PopupActionContainer,
  CancelButton,
  SaveButton,
  PopupContainer,
  PopupLabel,
  AddNewCategory,
  LoaderContainer,
  WarningLabel,
} from './styles';
import { getAllCategories, createCategory } from '../../utils/services/categoriesAPI';
import { validateEmailElementName } from '../../utils/services/mailTemplateAPI';
import { validateDocElementName } from '../../utils/services/elementAPI';
import { AppStoreContext } from '../../context/appStoreContext';
import { getGroupPermission } from '../../utils/services/teamsAPI';
import Loader from '../../components/Loader';
import NoTeam from '../../components/NoTeam';
import { CREATE_NEW_ELEMENT_MODAL } from "./translationValues";
import { withTranslation } from 'react-i18next';

const NAMESPACES=['CREATE_NEW_ELEMENT_MODAL']

const { Option } = Select;

const CreateNewRefElement = props => {
  const { visible, onCancel, isReferenced, isEmailElements, t } = props;
  const [allCategories, setAllCategories] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [newRefElementName, setnewRefElementName] = useState(null);
  const [savingLoader, setSavingLoader] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState(null);
  const [validCategName, setValidCategName] = useState(false);
  const [savePopupVisible, setSavePopupVisible] = useState(false);
  const [warningText, setWarningText] = useState('');
  const {
    updateRefElementName,
    setRefElementDetails,
    setElementPageDetail,
    setDocumentVariables,
    resourceGroupId,
    setResourceGroupId,
    userDetails,
    checkUserAccess,
  } = useContext(AppStoreContext);
  const [savingCategory, setSavingCategory] = useState(false);
  const [allTeams, setAllTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noTeam, setnoTeam] = useState(false);

  const history = useHistory();
  const userType = userDetails.userType;

  useEffect(() => {
    (async () => {
      setResourceGroupId(undefined);
      setElementPageDetail([]);
      const response = await getAllCategories(true);
      if (response && response.data) {
        let loggedUserCategory = response.data.filter(
          categoryObj => userType === categoryObj.categoryusertype,
        );
        setAllCategories(loggedUserCategory);
      }
      const teamData = await getGroupPermission(true);
      if (teamData?.data) {
        setLoading(false);
        if (teamData.data.length === 1) {
          setResourceGroupId(teamData.data[0].rgId);
        }
        if (teamData.length === 0) {
          setnoTeam(true);
        }
        setAllTeams(teamData.data);
      } else {
        setnoTeam(true);
        setLoading(false);
      }
    })();
    // eslint-disable-next-line
  }, []);

  const saveNewElement = async () => {
    updateRefElementName(newRefElementName);
    let payload = {
      name: newRefElementName,
      categoryId: selectedCategoryId,
      referenced: isReferenced,
      resourceGroupId: Number(resourceGroupId),
    };
    setRefElementDetails(payload);
    setDocumentVariables([]);
    if (payload) {
      if (isEmailElements) {
        history.push('/emailElementDesign/newElement');
      } else {
        history.push('/elementDesign/newElement');
      }
    }
  };
  const setCategoryName = categoryName => {
    setNewCategoryName(categoryName);
    setValidCategName(categoryName.split(' ').join('').length);
  };

  const handlePopupVisibleChange = visible => {
    setSavePopupVisible(visible);
  };
  const saveNewCategory = () => {
    setSavingCategory(true);
    let payload = {
      name: newCategoryName,
      type: 'element',
    };
    createNewCategory(payload);
  };
  const createNewCategory = async payload => {
    let categoryResponse = await createCategory(payload);
    if (categoryResponse && categoryResponse.errors && categoryResponse.errors.length === 0) {
      const savedCategory = {
        createdBy: null,
        createdOn: null,
        elements: null,
        id: categoryResponse.id,
        name: payload.name,
        parentId: 0,
        status: 'active',
        type: 'template',
        updatedBy: null,
        updatedOn: null,
      };
      setAllCategories(allCategories => [...allCategories, savedCategory]);
      setSavePopupVisible(false);
      setSelectedCategoryId(categoryResponse.id);
      setNewCategoryName(null);
      setSavingCategory(false);
    } else {
      setSavingCategory(false);
    }
  };

  const validatElementName = async () => {
    let payload = {
      name: newRefElementName,
      referenced: isReferenced,
    };
    if (isEmailElements) {
      const response = await validateEmailElementName(payload);
      if (
        response &&
        response.errors &&
        response.errors.length > 0 &&
        response.statusCode === 1403
      ) {
        setWarningText(t(CREATE_NEW_ELEMENT_MODAL.ELEMENT_NAME_ALREADY_EXISTS_WARNING_MESSAGE.key, CREATE_NEW_ELEMENT_MODAL.ELEMENT_NAME_ALREADY_EXISTS_WARNING_MESSAGE.value));
      }
    } else {
      const response = await validateDocElementName(payload);
      if (response && response.data) {
        if (response && response.data.nameExist) {
          setWarningText(t(CREATE_NEW_ELEMENT_MODAL.ELEMENT_NAME_ALREADY_EXISTS_WARNING_MESSAGE.key, CREATE_NEW_ELEMENT_MODAL.ELEMENT_NAME_ALREADY_EXISTS_WARNING_MESSAGE.value));
        }
      }
    }
  };

  const changeElementName = name => {
    setnewRefElementName(name.trimStart());
    updateRefElementName(name.trimStart());
    if (name.split(' ').join('').length) {
      setWarningText('');
    } else {
      setWarningText(t(CREATE_NEW_ELEMENT_MODAL.ENTER_VALID_NAME_WARNING_MESSAGE.key, CREATE_NEW_ELEMENT_MODAL.ENTER_VALID_NAME_WARNING_MESSAGE.value));
    }
  };
  

  const renderLoader = () => (
    <LoaderContainer>
      <Loader />
    </LoaderContainer>
  );

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={isReferenced ? t(CREATE_NEW_ELEMENT_MODAL.CREATE_REFERENCED_ELEMENT_TITLE.key, CREATE_NEW_ELEMENT_MODAL.CREATE_REFERENCED_ELEMENT_TITLE.value) : t(CREATE_NEW_ELEMENT_MODAL.NEW_ELEMENT_TITLE.key, CREATE_NEW_ELEMENT_MODAL.NEW_ELEMENT_TITLE.value)}
        centered
        maskClosable={false}
        visible={visible}
        onOk={onCancel}
        onCancel={onCancel}
        footer={null}
        className="design_modal"
      >
        <ModalBody>
          <ModalContainer>
            {loading ? (
              renderLoader()
            ) : noTeam ? (
              <NoTeam type="element" />
            ) : (
              <>
                <InputContainer>
                  <InputLabel>{t(CREATE_NEW_ELEMENT_MODAL.ELEMENT_NAME_LABEL.key, CREATE_NEW_ELEMENT_MODAL.ELEMENT_NAME_LABEL.value)}</InputLabel>
                  <Input
                    placeholder={t(CREATE_NEW_ELEMENT_MODAL.TEMPLATE_NAME_PLACEHOLDER.key, CREATE_NEW_ELEMENT_MODAL.TEMPLATE_NAME_PLACEHOLDER.value)}
                    autoComplete="off"
                    name="templateName"
                    value={newRefElementName}
                    onChange={e => {
                      changeElementName(e.target.value);
                    }}
                    onBlur={() => validatElementName()}
                    size="large"
                  />
                  {warningText && <WarningLabel>{warningText}</WarningLabel>}
                </InputContainer>
                <InputContainer>
                  <AddNewCategory>
                    <Popover
                      content={
                        <PopupContainer>
                          <PopupLabel>{t(CREATE_NEW_ELEMENT_MODAL.CATEGORY_NAME_LABEL.key, CREATE_NEW_ELEMENT_MODAL.CATEGORY_NAME_LABEL.value)}</PopupLabel>
                          <Input
                            placeholder={t(CREATE_NEW_ELEMENT_MODAL.CATEGORY_NAME_PLACEHOLDER.key, CREATE_NEW_ELEMENT_MODAL.CATEGORY_NAME_PLACEHOLDER.value)}
                            autoComplete="off"
                            name="categoryName"
                            value={newCategoryName}
                            onChange={e => setCategoryName(e.target.value)}
                          />
                          <PopupActionContainer>
                            <CancelButton
                              size="default"
                              onClick={() => handlePopupVisibleChange(false)}
                            >
                              {t(CREATE_NEW_ELEMENT_MODAL.CANCEL_BUTTON.key, CREATE_NEW_ELEMENT_MODAL.CANCEL_BUTTON.value)}
                            </CancelButton>
                            <SaveButton
                              type="primary"
                              size="default"
                              onClick={() => saveNewCategory()}
                              disabled={!newCategoryName || !validCategName}
                              loading={savingCategory}
                            >
                              {savingCategory ? t(CREATE_NEW_ELEMENT_MODAL.SAVE_LOADING.key, CREATE_NEW_ELEMENT_MODAL.SAVE_LOADING.value) : t(CREATE_NEW_ELEMENT_MODAL.SAVE_BUTTON.key, CREATE_NEW_ELEMENT_MODAL.SAVE_BUTTON.value)}
                            </SaveButton>
                          </PopupActionContainer>
                        </PopupContainer>
                      }
                      placement="leftBottom"
                      trigger="click"
                      visible={savePopupVisible}
                      onVisibleChange={handlePopupVisibleChange}
                    >
                      <Icon type="plus" /> {t(CREATE_NEW_ELEMENT_MODAL.ADD_NEW_ACTION.key, CREATE_NEW_ELEMENT_MODAL.ADD_NEW_ACTION.value)}
                    </Popover>
                  </AddNewCategory>
                  <InputLabel>{t(CREATE_NEW_ELEMENT_MODAL.CATEGORY_LABEL.key, CREATE_NEW_ELEMENT_MODAL.CATEGORY_LABEL.value)}</InputLabel>
                  <Select
                    loading={!allCategories}
                    showSearch
                    placeholder={t(CREATE_NEW_ELEMENT_MODAL.CATEGORY_PLACEHOLDER.key, CREATE_NEW_ELEMENT_MODAL.CATEGORY_PLACEHOLDER.value)}
                    optionFilterProp="children"
                    value={selectedCategoryId ? selectedCategoryId : undefined}
                    onChange={value => setSelectedCategoryId(value)}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {allCategories &&
                      allCategories.map(data => {
                        return (
                          <Option key={String(data.id)} value={data.id}>
                            {data.name}
                          </Option>
                        );
                      })}
                  </Select>
                </InputContainer>
                {allTeams.length > 1 && (
                  <InputContainer>
                    <InputLabel>{t(CREATE_NEW_ELEMENT_MODAL.SELECT_TEAM_LABEL.key, CREATE_NEW_ELEMENT_MODAL.SELECT_TEAM_LABEL.value)}</InputLabel>
                    <Select
                      loading={!allTeams}
                      showSearch
                      placeholder={t(CREATE_NEW_ELEMENT_MODAL.SELECT_TEAM_PLACEHOLDER.key, CREATE_NEW_ELEMENT_MODAL.SELECT_TEAM_PLACEHOLDER.value)}
                      optionFilterProp="children"
                      value={resourceGroupId || undefined}
                      onChange={value => setResourceGroupId(value)}
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {allTeams &&
                        allTeams.map(data => {
                          return (
                            <Option key={String(data.id)} value={data.rgId}>
                              {data.groupName}
                            </Option>
                          );
                        })}
                    </Select>
                  </InputContainer>
                )}
                <InputContainer>
                  <div className="form_btn">
                    <Button
                      key="submit"
                      type="primary"
                      disabled={
                        !newRefElementName ||
                        !selectedCategoryId ||
                        (checkUserAccess('client') && !resourceGroupId) ||
                        warningText
                      }
                      loading={savingLoader}
                      onClick={() => saveNewElement()}                    
                    >
                      {savingLoader ? t(CREATE_NEW_ELEMENT_MODAL.CREATE_LOADING.key, CREATE_NEW_ELEMENT_MODAL.CREATE_LOADING.value) : t(CREATE_NEW_ELEMENT_MODAL.CREATE_BUTTON.key, CREATE_NEW_ELEMENT_MODAL.CREATE_BUTTON.value)}
                    </Button>
                  </div>
                </InputContainer>
              </>
            )}
          </ModalContainer>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default withTranslation(NAMESPACES)(CreateNewRefElement);
